/**
 * Dependencies.
 */
import ServicePointModel from '@/api/address/service-point.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class ServicePointService extends BaseService<ServicePointModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      ServicePointModel,
      ServicePointModel.name,
      applicationConstant.apiCustomerPrivateUrl
    );
  }
}

/**
 * Export `servicePointService`.
 */
export const servicePointService = new ServicePointService();
